import React, { FC } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import rotatingGears from "@/assets/lottie/rotating-gears.lottie?url";
import { Flex, Text } from "@chakra-ui/react";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";
import InactiveTileContentLayout from "@/js/components/StudentTile/components/inactiveScreenStates/InactiveTileContentLayout";

const StudentReconnecting: FC = () => {
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex flexDirection={"column"} align={"center"} height={tileSize !== "sm" ? "100%" : ""}>
			<DotLottieReact
				src={rotatingGears}
				loop
				autoplay
				style={{ width: tileSize !== "sm" ? "64px" : "45px", height: tileSize !== "sm" ? "71px" : "40px" }}
			/>
			<InactiveTileContentLayout>
				<Text fontWeight={"bold"}>Got it!</Text>
				<Text>We're working on it now.</Text>
			</InactiveTileContentLayout>
		</Flex>
	);
};

export default StudentReconnecting;
